import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Container,
  Row,
} from "reactstrap"

import SalesChart from "./SalesChart"
import TopSellingQty from "./TopSellingQty"
import TopSellingAmt from "./TopSellingAmt"
import TopSellingPft from "./TopSellingPft"
import TopCustomer from "./TopCustomer"
import MiniWidget from "./mini-widget"

const Dashboard = props => {

  const items = [
    {
      icon: "bx bx-copy-alt",
      title: "Add Sales",
      link: "/add-sales",
      clazz: "col-pal-1"
    },
    {
      icon: "bx bx-archive-in",
      title: "Add Purchase",
      link: "/add-purchase",
      clazz: "col-pal-2"
    },
    {
      icon: "bx bx-purchase-tag-alt",
      title: "All Products",
      link: "/view-products",
      clazz: "col-pal-3"
    },
    {
      icon: "bx bx-receipt",
      title: "All Sales",
      link: "/view-sales-entries",
      clazz: "col-pal-4"
    },
  ];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Dashboard | Flamingo</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Home" breadcrumbItem="Dashboard" />
            <Row>
              <MiniWidget items={items} />
            </Row>
            <Row>
              <SalesChart/>
            </Row>
            <Row>
              <TopSellingQty/>
              <TopSellingAmt/>
              <TopSellingPft/>
              <TopCustomer/>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
}

export default Dashboard;
